import {Amplify, AuthConfig} from '@aws-amplify/core';
import {cognitoUserPoolsTokenProvider} from '@aws-amplify/auth/cognito';
import {SecretsInterface} from '../../interfaces/secrets/secrets.interface';

export function configureCognitoAuth(secrets: SecretsInterface, storage: Storage): void {
    const auth: AuthConfig = {Cognito: {
        userPoolId: secrets.userPoolId,
        userPoolClientId: secrets.userPoolWebClientId,
    }};
    cognitoUserPoolsTokenProvider.setKeyValueStorage({
        getItem: async key => storage.getItem(key),
        setItem: async (key, value) => storage.setItem(key, value),
        removeItem: async key => storage.removeItem(key),
        clear: async () => storage.clear(),
    });
    cognitoUserPoolsTokenProvider.setAuthConfig(auth);
    Amplify.configure({Auth: auth}, {Auth: {tokenProvider: cognitoUserPoolsTokenProvider}});
}

// The backend refresh contract needs fields intentionally omitted by fetchAuthSession.
// Keep this version-sensitive SDK storage access isolated and covered by integration tests.
export async function readCognitoRefreshCredentials(username: string): Promise<{refreshToken: string; deviceKey?: string}> {
    const tokens = await cognitoUserPoolsTokenProvider.authTokenStore.loadTokens();
    if (!tokens || tokens.username !== username || !tokens.refreshToken) {
        throw new Error('Cognito refresh credentials do not match the authenticated user.');
    }
    return {refreshToken: tokens.refreshToken, deviceKey: tokens.deviceMetadata?.deviceKey};
}
